import { ClickEvent } from "@mcleod/components";
import {AutogenLayoutAuditLogQuery } from "./autogen/AutogenLayoutAuditLogQuery";
import { DateRange, DisplayType, DisplayValue } from "@mcleod/core";

export class AuditLogQuery extends AutogenLayoutAuditLogQuery{

    override async onLoad(): Promise<void> {
        const defaultDateRange = DateRange.parseDateRangeWithKeywords("t-7,t");
        this.textboxStartDateTime.text = DisplayValue.getDisplayValue(defaultDateRange.startDate, DisplayType.DATETIME);
        this.textboxEndDateTime.text = DisplayValue.getDisplayValue(defaultDateRange.endDate, DisplayType.DATETIME);
    }
}
